/**
 * Rebuy Smart Cart / theme cart drawer conflict fix.
 * Hallway Customisation
 * https://hallway.co.uk
 *
 * The store uses Rebuy Smart Cart as its cart UI. Rebuy opens itself whenever an
 * item is added to the cart. The theme, however, also opens its own native
 * <cart-drawer> in several add-to-cart flows (notably the quick-view flow in
 * theme.js, which calls `cartDrawer.show()` after the quick view closes).
 *
 * When both fire, the theme drawer ends up "open"/"active" but hidden behind the
 * Rebuy cart. Once the Rebuy cart is dismissed, the theme drawer is still open,
 * leaving its invisible <overlay-element> + `.drawer__inner` intercepting clicks
 * on the page (with the overlay's "close" cursor as the only visible hint).
 *
 * This script prevents the theme's <cart-drawer> from opening while Rebuy Smart
 * Cart is the active cart, WITHOUT modifying any core theme JS. It monkey-patches
 * CartDrawer.prototype.show() once the custom element is defined. It is a no-op
 * when Rebuy Smart Cart isn't present, so the native drawer keeps working
 * normally on any page/store where Rebuy isn't loaded.
 */
(function () {
  'use strict';

  var REBUY_SMART_CART_SELECTOR =
    'rebuy-smart-cart, rebuy-cart, #rebuy-cart, #rebuy-smart-cart, .rebuy-cart-flyout, .rebuy-smart-cart, [data-rebuy-smart-cart]';

  function isRebuySmartCartActive() {
    if (window.Rebuy && (window.Rebuy.SmartCart || window.Rebuy.smartCart)) {
      return true;
    }

    return document.querySelector(REBUY_SMART_CART_SELECTOR) !== null;
  }

  if (!window.customElements || typeof customElements.whenDefined !== 'function') {
    return;
  }

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');

    if (!CartDrawer || CartDrawer.prototype.__rebuySmartCartPatched) {
      return;
    }

    var originalShow = CartDrawer.prototype.show;

    CartDrawer.prototype.show = function () {
      // Never open the theme drawer while Rebuy Smart Cart is the active cart.
      if (isRebuySmartCartActive()) {
        return;
      }

      return originalShow.apply(this, arguments);
    };

    CartDrawer.prototype.__rebuySmartCartPatched = true;
  });
})();

